interface ViewStateKeyOptions {
    routeName?: string;
    routeParams?: Record<string, unknown>;
    sitemapId?: string | null;
    licence?: string | null;
    mode?: string | null;
    endpoint?: string | null;
    parentType?: string | null;
    parentId?: string | null;
    actionName?: string | null;
    scope?: string | null;
}

const sanitize = (value: unknown): string =>
{
    if (value === null || value === undefined) return '';

    return String(value).trim();
};

const stableParams = (params?: Record<string, unknown>): string =>
{
    if (!params) return '';

    return Object.keys(params)
        .sort((a, b) => a.localeCompare(b))
        .map((key) => `${key}:${sanitize(params[key])}`)
        .filter(Boolean)
        .join('|');
};

export const createViewStateKey = (options: ViewStateKeyOptions): string =>
{
    const routeName = sanitize(options.routeName) || 'unknown-route';
    const params = stableParams(options.routeParams);

    const identity = sanitize(options.sitemapId)
        || sanitize(options.endpoint)
        || [sanitize(options.licence), sanitize(options.mode)].filter(Boolean).join('/')
        || 'unknown-view';

    const actionSegment = sanitize(options.actionName) || sanitize(options.mode);

    const context = [
        sanitize(options.parentType),
        sanitize(options.parentId),
        actionSegment,
        sanitize(options.scope),
    ].filter(Boolean).join('|');

    const parts = [routeName, params, identity, context].filter(Boolean);

    return parts.join('::');
};
